import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import About from "@/components/About";
import MeetMarc from "@/components/MeetMarc";
import Portfolio from "@/components/Portfolio";
import Process from "@/components/Process";
import Testimonials from "@/components/Testimonials";
import ServiceAreas from "@/components/ServiceAreas";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-[#080A0B] text-[#F4F0EB] min-h-screen">
      <Nav />
      <Hero />
      <Contact />
      <Marquee />
      <Services />
      <MeetMarc />
      <About />
      <Portfolio />
      <Process />
      <Testimonials />
      <ServiceAreas />
      <Footer />
    </main>
  );
}
